import { takeEvery, call, all, fork, put } from "@redux-saga/core/effects";
import { FETCH_CREDENTIALS } from "redux/constants/portal";
import {
  setIsLoadingCredentials,
  setCredentials
} from "redux/actions/portal/credentialManagementActionCreator";
import { getTenantCredentials } from "api/CredentialManagementApi";

/***** WORKERS *****/

function* handleFetchCredentials({ payload }) {
  try {
    const { tenant_id, auth0_id } = payload;

    yield put(setIsLoadingCredentials(true));

    let response = yield call(getTenantCredentials, tenant_id, auth0_id);

    yield put(setCredentials(response.resultObject));
    yield put(setIsLoadingCredentials(false));
  } catch (error) {
    console.error(error);
    yield put(setIsLoadingCredentials(false));
  }
}

/***** WATCHERS *****/

function* watchFetchCredentials() {
  yield takeEvery(FETCH_CREDENTIALS, handleFetchCredentials);
}

export function* rootCredentialManangementSaga() {
  yield all([fork(watchFetchCredentials)]);
}
